import {
  MEMBERS_SORT_COLUMN_LABELS,
  MembersSortField,
} from "@components/table/members/members-table-constants";
import { MembersSortBy } from "@custom-types/member-types";
import { SortItem, SortOption } from "@custom-types/sort-types";
import { FaroCoreApiTypes } from "@stellar/core-api-client";

/** Default workspace members sort by option */
export const DEFAULT_WORKSPACE_MEMBERS_SORT_BY: MembersSortBy =
  "user_ascending";

/** Default project/group members sort by option */
export const DEFAULT_MEMBERS_SORT_BY: MembersSortBy = "name_ascending";

export const DEFAULT_TEAM_MEMBERS_SORT_BY: FaroCoreApiTypes.TeamMemberSortBy =
  "newest_first";
  
/** Available members sort field options */
export const MEMBERS_SORT_OPTIONS: Record<
  MembersSortField,
  SortOption<MembersSortField>
> = {
  user: {
    field: "user",
    label: MEMBERS_SORT_COLUMN_LABELS.user,
  },
  name: {
    field: "name",
    label: MEMBERS_SORT_COLUMN_LABELS.name,
  },
  email: {
    field: "email",
    label: MEMBERS_SORT_COLUMN_LABELS.email,
  },
  status: {
    field: "status",
    label: MEMBERS_SORT_COLUMN_LABELS.status,
  },
  role: {
    field: "role",
    label: MEMBERS_SORT_COLUMN_LABELS.role,
  },
  joinedDate: {
    field: "joinedDate",
    label: MEMBERS_SORT_COLUMN_LABELS.joinedDate,
  },
};

/** Map of the sort by options to the SortItem format */
export const MEMBERS_SORT_BY_MAP: Record<
  MembersSortBy,
  SortItem<MembersSortField>
> = {
  ["user_ascending"]: {
    field: "user",
    sort: "asc",
  },
  ["user_descending"]: {
    field: "user",
    sort: "desc",
  },
  ["name_ascending"]: {
    field: "name",
    sort: "asc",
  },
  ["name_descending"]: {
    field: "name",
    sort: "desc",
  },
  ["email_ascending"]: {
    field: "email",
    sort: "asc",
  },
  ["email_descending"]: {
    field: "email",
    sort: "desc",
  },
  ["status_ascending"]: {
    field: "status",
    sort: "asc",
  },
  ["status_descending"]: {
    field: "status",
    sort: "desc",
  },
  ["role_ascending"]: {
    field: "role",
    sort: "asc",
  },
  ["role_descending"]: {
    field: "role",
    sort: "desc",
  },
  ["joinedDate_ascending"]: {
    field: "joinedDate",
    sort: "asc",
  },
  ["joinedDate_descending"]: {
    field: "joinedDate",
    sort: "desc",
  },
};

export type TeamMembersSortField = "joinedDate";

/** Available team members sort field options */
export const TEAM_MEMBERS_SORT_OPTIONS: Record<
  TeamMembersSortField,
  SortOption<TeamMembersSortField>
> = {
  joinedDate: {
    field: "joinedDate",
    label: MEMBERS_SORT_COLUMN_LABELS.joinedDate,
  },
};

/** Map of team member sort options to SortItem format */
export const TEAM_MEMBERS_SORT_BY_MAP: Record<
  FaroCoreApiTypes.TeamMemberSortBy,
  SortItem<TeamMembersSortField>
> = {
  ["newest_first"]: {
    field: "joinedDate",
    sort: "desc",
  },
  ["oldest_first"]: {
    field: "joinedDate",
    sort: "asc",
  },
};
